import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeZh from '@angular/common/locales/zh';

/**
 * Dati di formattazione di ogni lingua offerta, da entrambe le porte: le sei del cittadino
 * (`ENVIRONMENT.contentLanguages`, italiano compreso) e quella della postazione
 * (`ENVIRONMENT.operatorLanguages`, che e' la stessa). Angular
 * ne porta di serie solo l'inglese: senza questa registrazione una data in italiano, in arabo, in cinese,
 * in francese o in spagnolo va in errore, e il ripiego
 * sarebbe mostrare a tutti il formato americano — 8/1/26 letto da un italiano e' l'8 gennaio, non il primo
 * agosto. Si registra una volta all'avvio; `registerLocaleData` sovrascrive la voce, quindi richiamarla e'
 * innocuo (i test la richiamano per conto proprio).
 */
export function registerSupportedLocaleData(): void {
  registerLocaleData(localeIt, 'it');
  registerLocaleData(localeAr, 'ar');
  registerLocaleData(localeEs, 'es');
  registerLocaleData(localeFr, 'fr');
  registerLocaleData(localeZh, 'zh');
}
